import VerticalDotsMenu from './VerticalDotsMenu';

export default VerticalDotsMenu;
